import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'neu-charts',
  template: `<h3>Neu-charts works!</h3>
`,
  styles: [``]
})
export class NeuChartsComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
